// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"43996cbb","879":"8c41a1c2"}[chunkId] + ".chunk.js";
};